import { render, staticRenderFns } from "./newBoost.vue?vue&type=template&id=be366edc&scoped=true"
import script from "./newBoost.vue?vue&type=script&lang=js"
export * from "./newBoost.vue?vue&type=script&lang=js"
import style0 from "./newBoost.vue?vue&type=style&index=0&id=be366edc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.5.0_webpack@5.112.0_postcss@8.5.30___lodash@4.18.1_vue-_4fe22dd29fe357c1ce04fb09946be568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be366edc",
  null
  
)

export default component.exports